import React from 'react';
import PropTypes from 'prop-types';
import strings from 'localization/strings';
import storageGroupCategories from 'enums/storageGroupCategories';
import landingPages from 'enums/landingPages';
import { getGeographyLocationLandingPageUrl } from 'helpers/GeographyHelper';

import MarginBox from 'common/MarginBox';
import { Link } from 'react-router-dom';

const AllStorageSitesForLocation = ({ storageSite, storageGroupCategory }) => {
    const landingPage = landingPages[storageGroupCategory.key];
    return (
        <MarginBox top={2}>
            <Link to={getGeographyLocationLandingPageUrl(landingPage, storageSite.city)}>
                {strings.formatString(storageGroupCategories[storageGroupCategory.key].allStorageSitesInX, storageSite.city)}
            </Link>
        </MarginBox>
    );
};

AllStorageSitesForLocation.propTypes = {
    storageSite: PropTypes.object.isRequired,
    storageGroupCategory: PropTypes.object.isRequired
};

export default AllStorageSitesForLocation;
